/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GroupMessJobDetailCreate } from './GroupMessJobDetailCreate';
export type GroupMessJobSaveAsRequest = {
    /**
     * Name of the new group messjob
     */
    name: string;
    /**
     * Creation mode for the group messjob
     */
    creation_mode: GroupMessJobSaveAsRequest.creation_mode;
    parent_messjob_id: string;
    messproject_id: string;
    group_messjob_detail: Array<GroupMessJobDetailCreate>;
};
export namespace GroupMessJobSaveAsRequest {
    /**
     * Creation mode for the group messjob
     */
    export enum creation_mode {
        SIMPLE = 'simple',
        INCREMENTAL = 'incremental',
        ROLLATING = 'rollating',
    }
}

